// extracted by mini-css-extract-plugin
export default {"childWrapper":"styles_childWrapper__QxgJV","fullWidth":"styles_fullWidth__aYlLp","inline":"styles_inline__Y3YKc"};